import { createIdStore } from "@/listings/listing.marks.ts";

/**
 * Listings you said you were interested in.
 *
 * The counterpart to `listing.seen.ts`, and deliberately the opposite kind of
 * signal: seen is passive bookkeeping the app writes for you, this is the one
 * mark you make on purpose. So it is the one that gets to change a pin's colour
 * outright rather than add an ornament to it — a shortlist is worth finding
 * across a full map, and by the time something is on it you already know how old
 * it is.
 *
 * Far smaller than the seen set, so a far smaller cap: a shortlist that ran to
 * four figures would not be a shortlist.
 */
const store = createIdStore({ key: "radar.tracked.v1", limit: 500, label: "TrackedIds" });

export const useTrackedListings = store.use;
export const toggleTracked = store.toggle;
export const clearTracked = store.clear;
